
import { useEffect } from "react";
import { useForm } from "react-hook-form";

import { FloatingInputBootStrap } from "../Common/FloatingInputBootstrap";

import PasswordSetter from "../Common/PasswordSetter.tsx";
import { useRegisterRequest, type RegisterRequestHookParam } from "../../services/Login.ts";
import { useTrads } from "../../contexts/trads/useTrads.tsx";
import ReglementField from "../Common/ReglementField.tsx";

interface PasswordVerif {
    password_verif:string
};

interface RegisterData extends RegisterRequestHookParam, PasswordVerif {};


function RegisterForm(){
        const { register,setError,watch,handleSubmit, formState: { errors }  } = useForm({
        defaultValues:{identifiant:"",password:"",password_verif:"",email:"",reglement:undefined} as RegisterData,
        shouldUseNativeValidation: true,
        mode:'onSubmit',
    });

    const {result,registerRequest}=useRegisterRequest();
    const  onSubmit =  (data: RegisterData) => {
        registerRequest(data.identifiant,data.password,data.email,data.reglement);
    };
    const password=watch('password');
    const password_verif=watch('password_verif');
    const {translate}=useTrads();

    useEffect(()=>{
        if(result.error) {

            if(typeof result.error=='object'){
                for (const i in result.error) {
                    // @ts-expect-error i est connu!
                    setError(i, {type:'validate',message: translate(result.error[i])});  
                }
                //result.reset();
            }else{
                //erreur server ?
            }
        }
    },[setError,result,translate]);

    return (
        result.isSuccess ? <div className="register-form">{translate('register_page_success')}</div> : (
        result.error && typeof result.error=='object' && 'status' in result.error && result.error.status!='400' ? <div className="register-form">{translate('register_page_error')}</div> :
        result.isLoading ? <div className="register-form">{translate('register_page_loading')}</div> : (

        <form className="row" onSubmit={(event) => void handleSubmit(onSubmit)(event)}>
            <div className="col-12  mb-3">

                <FloatingInputBootStrap 
                    name='identifiant' 
                    label={translate('login_form_username')} 
                    type='text' 
                    registerOutput={register("identifiant", {
                        required: translate('register_login_required'),
                    })}
                    errors={errors}
                    rest={{"autoComplete" : "username"}}
                />

            </div>
            <div className="col-12  mb-3">

                <PasswordSetter 
                    name='password' 
                    label={translate('login_form_password')} 
                    registerOutput={register("password", {
                        required: translate('register_password_required'),
                        validate: (value) => {

                            if(password_verif && value !== password_verif){
                                return translate('password_verif_mismatch');
                            }
                            //return validatePassword(value);
                            return true;
                                    
                        }
                    })}
                    registerOutputValidation={
                        register("password_verif", {
                        required: translate('register_password_verif_required'),
                        validate: value => value === password || translate('password_verif_mismatch')
                    })
                    }
                    errors={errors}
                    rest={{"autoComplete" : "new-password"}}
                    restValidation={{"autoComplete" : "new-password"}}
                />

            </div>
            <div className="col-12  mb-3">

                <FloatingInputBootStrap 
                    name='email' 
                    label={translate('form_email_label')} 
                    type='email' 
                    registerOutput={register("email", {
                        required: translate('email_required'),
                    })}
                    errors={errors}
                    rest={{"autoComplete" : "email"}}
                />

            </div>
            <div className="col-12  mb-3">
                <ReglementField
                    label={translate('register_reglement')} 
                    name="reglement"
                    registerOutput={register("reglement", {
                        required: translate('reglement_required'),
                    })}
                    errors={errors}
                ></ReglementField>
            </div>
            <div className="col-12  mb-3">
                <button type="submit">{translate('form_submit_register')}</button>
            </div>
                
        </form>

        )
    )

    )
}

export default RegisterForm;